export default __webpack_public_path__ + "static/media/grid7.a69ff6d5.png";